<!-- 江苏兴业数币抽奖活动-步骤长图 -->
<template>
  <div class="step-long-diagram">
    <div class="header">
      <van-icon name="arrow-left" @click="back" />
      <span>{{ title }}</span>
      <div style="width: 30px; height: 5px"></div>
    </div>
    <img
      :src="require(`@/assets/imgs/jiangsuXingyeDigitalCoinLottery/step.jpg`)"
      alt=""
    />
  </div>
</template>
<script>

// import NotEligible from './components/NotEligible.vue'
export default {
  components: {},
  data () {
    return {
      title: '数币开通流程',
    }
  },
  created () {

  },
  methods: {
    back () {
      this.$router.back()
    }
  },
}
</script>
<style lang="less" scoped>
.step-long-diagram {
  .header {
    line-height: 3;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 2px;
    font-size: 14px;
    i {
      font-size: 22px;
      padding-right: 15px;
      color: #000;
    }
  }
  img {
    width: 100%;
  }
}
</style>
